if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          if (this.submitButton.id != "ProductSubmitButton-product-quickview") {
            this.cart.setActiveElement(document.activeElement);
          }
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            return this.clearBuyItNowLeftovers(response, formData).then((response) => {
              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
              this.error = false;
              const is_cart_page = document.body.classList.contains('template-cart');
              if (!is_cart_page) {
                this.cart.renderContents(response);
              }else{
                closePopup.hide();
              }
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      /**
       * Removes lines a "Buy it now" click (buy-it-now.js) left in the cart
       * when the shopper backed out of that checkout. Those lines carry a
       * private `_buy_it_now` property, which keeps them separate from the
       * shopper's own add-to-cart line for the same variant, so without this
       * an ordinary add would show the product twice.
       *
       * The cart drawer marks such lines with `data-buy-it-now-key`, and the
       * add response already contains the freshly rendered drawer, so nothing
       * extra is fetched unless there is something to clear. When there is,
       * the leftovers are removed and the sections re-rendered from the
       * cleaned cart before anything is shown, so the duplicate never
       * appears. Resolves with the response to render from either way.
       *
       * Only the cart drawer renders line items into this response; with the
       * "added message" cart type the leftovers are left for the next Buy it
       * now click to clear.
       */
      clearBuyItNowLeftovers(response, formData) {
        const updates = {};
        Object.values(response.sections || {}).forEach((html) => {
          if (typeof html !== 'string' || !html.includes('data-buy-it-now-key')) return;
          new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelectorAll('[data-buy-it-now-key]')
            .forEach((line) => {
              const key = line.dataset.buyItNowKey;
              if (key && key !== response.key) updates[key] = 0;
            });
        });
        if (!Object.keys(updates).length) return Promise.resolve(response);

        const body = JSON.stringify({
          updates,
          sections: formData.get('sections'),
          sections_url: formData.get('sections_url'),
        });
        return fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body })
          .then((res) => res.json())
          .then((updated) => (updated.sections ? { ...response, sections: updated.sections } : response))
          .catch(() => response);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
